<template>
  <div class="c-table" ref="designDetailtable">
    <Spin size="large" fix v-if="loading"></Spin>
    <el-table class="common-el-table-styles" :data="data" :height="height" border>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'type'">{{ scope.row[col.key] === 1 ? '系统生成' : '手动导入' }}</span>
          <span v-else-if="col.key === 'thirtyDaysAmount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'designDetailtable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  }
}
</script>
